export enum EProductTypePCA {
  Comprehensive = 0,
  BYO = 1
}
